/** Порог для подсказки: ступень по count, иначе первая из steps / legacy loss_avg_pct. */
export const resolveLossAvgHintPct = (params, lossAvgCount = 0) => {
    const steps = Array.isArray(params.loss_avg_steps) ? params.loss_avg_steps : [];
    if (steps.length > 0) {
        const idx = Math.max(0, Math.min(steps.length - 1, Math.floor(lossAvgCount)));
        const raw = Number(steps[idx]?.pnl_pct);
        return Number.isFinite(raw) && raw > 0 ? raw : 0;
    }
    const rawLossAvg = Number(params.loss_avg_pct);
    return Number.isFinite(rawLossAvg) && rawLossAvg > 0 ? rawLossAvg : 0;
};
/** Как backend `position_pnl_pct_net`: % с учётом комиссии продажи. */
export const positionPnlPctNet = (marketPrice, avgPrice, commissionRatePct = 0.3) => {
    if (avgPrice <= 0 || marketPrice <= 0)
        return 0;
    const sellRate = Math.max(0, commissionRatePct) / 100;
    const netExit = marketPrice * (1 - sellRate);
    return ((netExit - avgPrice) / avgPrice) * 100;
};
export const computeStrategyExitHints = (params, marketPrice, avgPrice, qty, commissionRatePct = 0.3, lossAvgCount = 0) => {
    if (qty <= 0 || avgPrice <= 0 || marketPrice <= 0) {
        return null;
    }
    const takeProfitPct = params.take_profit ?? 4;
    const stopLossPct = params.stop_loss ?? 2.5;
    const lossAvgPct = resolveLossAvgHintPct(params, lossAvgCount);
    // Согласовано с колонкой PnL / breakeven (комиссия на продажу).
    const pnlPct = positionPnlPctNet(marketPrice, avgPrice, commissionRatePct);
    return {
        pnlPct,
        takeProfitRemainingPct: takeProfitPct - pnlPct,
        stopLossDistancePct: pnlPct + stopLossPct,
        takeProfitPct,
        stopLossPct,
        lossAvgPct,
        atTakeProfit: pnlPct >= takeProfitPct,
        atStopLoss: pnlPct <= -stopLossPct,
        atLossAvg: lossAvgPct > 0 && pnlPct <= -lossAvgPct,
    };
};
export const strategySkipReasonKey = (reason) => {
    if (reason.startsWith("pretrade_")) {
        return "strategies.skipReason.pretrade";
    }
    return `strategies.skipReason.${reason}`;
};
export const strategySkipReasonParams = (reason) => {
    if (reason.startsWith("pretrade_")) {
        return { code: reason.slice("pretrade_".length) };
    }
    return undefined;
};
